import { render, staticRenderFns } from "./updateAddress.vue?vue&type=template&id=568e118c&scoped=true&"
import script from "./updateAddress.vue?vue&type=script&lang=js&"
export * from "./updateAddress.vue?vue&type=script&lang=js&"
import style0 from "./updateAddress.vue?vue&type=style&index=0&id=568e118c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e118c",
  null
  
)

export default component.exports